import { PressReleases } from 'src/db.js'
import { IssueLight } from './IssueEntity.js'
import { WarrantLight } from './WarrantEntity.js'
import { ConvertibleLight } from './ConvertibleEntity.js'
import { SelectType } from 'kysely'

export enum NewsType {
    NewsFlash,
    NewsArticle,
    PressRelease,
    CompanyFinancialCalendar,
    Report,
    MarketCommentary,
    EconomicCalendarToday,
    EconomicCalendarThisWeek,
    SystemsMessages,
}

export const SENDER_TYPE = {
    Company: 'company' as const,
    Finansinspektionen: 'Finansinspektionen' as const,
    AnalyzeAndIR: 'analyze-and-ir' as const,
}

export type SenderType = (typeof SENDER_TYPE)[keyof typeof SENDER_TYPE]

export type PressReleaseListFilter = {
    companyId?: string
    minPublicationDate?: string
    maxPublicationDate?: string
    search?: string
    senderType?: SenderType
    showOnlyReports?: boolean
    showOnlyWithRelatedTransactions?: boolean
}

type PressReleaseTranslation = {
    accuracyScore: number
    language: string
    prId: string
}

export type PressReleaseLight = Pick<
    SelectType<PressReleases>,
    'body' | 'companyId' | 'distributorName' | 'language' | 'publishedAt' | 'title' | 'id'
> & {
    newsType: NewsType | null
    relatedTransactions: Array<RelatedTransaction>
    translations: Array<PressReleaseTranslation>
}

type BaseRelatedTransaction = {
    id: string
    name: string | null
}

export type RelatedTransaction = BaseRelatedTransaction & (ConvertibleLight | IssueLight | WarrantLight)

export type PressReleaseEntity = PressReleaseLight & {
    attachments: Array<{ caption: string | null; mime: string | null; url: string }>
}
